<template>
  <div>
    <common-dialog ref="dialog" unit="工单下达" width="1300px" id-key="UserId" @close-saved="$emit('close-saved')" @closed="$emit('onClosed')"
      @details-opened="detailsOpened">
      <template slot="form">
        <el-row style="text-align: center; margin: 15px">
          <el-col :span="6">
            <div>
              <span>日期：</span>
              <el-date-picker
                v-model="ReleaseTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span>加工阶段：{{StageName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button type="primary"  @click="onQuery">查询</el-button>
          </el-col>
        </el-row>
        <el-table ref="table" class="table_bottom table-line tb-c-head" :data="tableData" border>
          <el-table-column prop="ProcessUnitName" label="加工单元" align="center" />
          <el-table-column prop="EquipmentQuantity" label="机台数" min-width="126" align="center" />
          <el-table-column prop="Workload" label="标准产能" min-width="126" align="center" />
          <el-table-column prop="SelectedQuantity" label="选中下达数量" min-width="110" align="center" />
          <el-table-column prop="IssuedQuantity" label="已下达数量" min-width="110" align="center" />
          <el-table-column prop="Subtotal" label="小计数量" min-width="110" align="center" />
          <el-table-column prop="IsOverfulfil" label="是否超产" min-width="110" align="center" />
        </el-table>
      </template>

      <template slot="footer">
        <el-button type="primary" @click="onSave">工单下达</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      api: require("@/api/production/workDoc").default,
      workDocApi: require("@/api/production/workDoc").default,
      WorkDocIds:[],
      warehouseList: [],
      tableData: [],
      WarehouseId: null,
      ReleaseTime: this.$commonJs.getToday(),
      total: null,
    };
  },
  props: {
    StageName: {
      type: String,
      default: "",
    }
  },
  methods: {
    detailsOpened(data) {
      this.WorkDocIds = data
      const o = {
        WorkDocIds: data,
        ReleaseTime: this.ReleaseTime,
      }

      this.api.ReviewSummary(o).then((res) => {
        console.log("ReviewSummary", res);
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });

    },
    onQuery(){
      const o = {
        WorkDocIds: this.WorkDocIds,
        ReleaseTime: this.ReleaseTime,
      }

      this.api.ReviewSummary(o).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });
    },
    onSave(){
      this.$confirm("确定下达这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.workDocApi.releaseReview({WorkDocIds:this.WorkDocIds}).then(res => {
          if (res.Code == 0) {
            this.$message.success("下达成功");
            this.$parent.reload();
            this.close(true);
          } else {
            this.$message.warning(res.Msg);
          }
        })
      });
    },
    close() {
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.$refs.dialog.close(true);
    },
  },
};
</script>
